/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from "react";
import { MdArrowBackIos } from "react-icons/md";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  ADD_GATEWAY_RATIO,
  GET_ALL_TRUSTEE_SCHOOL,
} from "../ManagePlatformCharges/Queries";
import { toast } from "react-toastify";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { GET_TRUSTEE_GATEWAY_RATIO } from "../ManageMdr/Queries";
// const paymentMethod: any = {
//   "DEBIT CARD": "debit_card",
//   "CREDIT CARD": "credit_card",
//   UPI: "upi",
//   WALLETS: "wallet",
//   "PAY LATER": "pay_later",
//   "CARDLESS EMI": "cardless_emi",
//   NETBANKING: "net_banking",
// };
// const invertedPaymentMethod: any = {
//   debit_card: "DEBIT CARD",
//   credit_card: "CREDIT CARD",
//   upi: "UPI",
//   wallet: "WALLETS",
//   pay_later: "PAY LATER",
//   cardless_emi: "CARDLESS EMI",
//   net_banking: "NETBANKING",
// };

function GatewayRatio({ handleInputChange, method }: any) {
  const [ratios, setRatios] = useState([100, 0, 0]);

  const handleChange = (index: number, value: number) => {
    if (isNaN(value)) return;

    let newValue = Math.min(Math.max(Math.round(value), 0), 100);

    const remaining = 100 - newValue;
    const others = [0, 1, 2].filter((i) => i !== index);

    let each = Math.floor(remaining / 2);
    let extra = remaining % 2;

    const newRatios = [...ratios];
    newRatios[index] = newValue;
    newRatios[others[0]] = each + (extra > 0 ? 1 : 0);
    newRatios[others[1]] = each;

    handleInputChange(method.mode, {
      cashfree: newRatios[0],
      easebuzz: newRatios[1],
      razorpay: newRatios[2],
      mode: method.mode,
    });

    setRatios(newRatios);
  };

  return (
    <div className="flex w-full gap-4">
      <input
        id={`gateway-${method.mode}`}
        type="number"
        value={method.cashfree}
        onChange={(e) => handleChange(0, Number(e.target.value))}
        className={
          "focus:outline-none disabled:bg-gray-200 transition-all duration-150 ease-in-out text-xs font-normal text-[#1B163B] px-2 py-1.5 w-full lg:max-w-[80%] rounded-md text-right "
        }
      />
      <input
        id={`gateway-${method.mode}`}
        type="number"
        value={method.easebuzz}
        onChange={(e) => handleChange(1, Number(e.target.value))}
        className={
          "focus:outline-none disabled:bg-gray-200 transition-all duration-150 ease-in-out text-xs font-normal text-[#1B163B] px-2 py-1.5 w-full lg:max-w-[80%] rounded-md text-right "
        }
      />
      <input
        id={`gateway-${method.mode}`}
        type="number"
        value={method.razorpay}
        onChange={(e) => handleChange(2, Number(e.target.value))}
        className={
          "focus:outline-none disabled:bg-gray-200 transition-all duration-150 ease-in-out text-xs font-normal text-[#1B163B] px-2 py-1.5 w-full lg:max-w-[80%] rounded-md text-right "
        }
      />
    </div>
  );
}

function SetGatwayRate({ setOpen, trusteeId }: any) {
  const {
    data: trustee_gateway_ratio,
    refetch,
    loading: gateway_ratio_loading,
  } = useQuery(GET_TRUSTEE_GATEWAY_RATIO, {
    variables: {
      trustee_id: trusteeId,
    },
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  const [allSchoolsIds, setAllSchoolsIds] = useState<any>([]);

  const [updateGatewayRatio, { loading }] = useMutation(ADD_GATEWAY_RATIO, {
    refetchQueries: [
      {
        query: GET_TRUSTEE_GATEWAY_RATIO,
        variables: { trustee_id: trusteeId },
      },
    ],
  });
  const [paymentMethods, setPaymentMethods] = useState<any>([]);

  useEffect(() => {
    const updatedPaymentMethods =
      trustee_gateway_ratio?.getTrusteeGatewayRatio?.map((method: any) => {
        return {
          ...method,
          razorpay: 0,
        };
      });

    setPaymentMethods(updatedPaymentMethods);
  }, [trustee_gateway_ratio]);
  const handleInputChange = (field: any, value: any) => {
    const updatedPaymentMethods = paymentMethods?.map(
      (method: any, i: number) => {
        if (method.mode === field) {
          return {
            ...method,
            ...value,
          };
        }
        return method;
      }
    );

    setPaymentMethods(updatedPaymentMethods);
  };

  const [getTrusteeSchools, { data: trustee_school_data }] = useLazyQuery(
    GET_ALL_TRUSTEE_SCHOOL
  );

  useEffect(() => {
    if (trustee_school_data && trustee_school_data.getAllTrusteeSchool) {
      let all_school_ids: any = [];
      trustee_school_data.getAllTrusteeSchool.forEach(
        (curr_trustee_school: any) => {
          all_school_ids.push(curr_trustee_school?.school_id);
        }
      );
      setAllSchoolsIds(all_school_ids);
    }
  }, [trustee_school_data]);

  useEffect(() => {
    if (!trusteeId) return;
    getTrusteeSchools({
      variables: {
        trusteeId: trusteeId,
      },
    });
  }, [trusteeId, getTrusteeSchools]);

  const gatwayRatio = paymentMethods?.map((d: any) => {
    return {
      cashfree: d?.cashfree,
      easebuzz: d?.easebuzz,
      razorpay: d?.razorpay,
      mode: d.mode,
    };
  });

  return (
    <div>
      <div className="p-4 flex bg-white justify-between items-center overflow-hidden">
        <p
          onClick={() => {
            const val = confirm("Changes will not be saved");
            if (val) {
              setOpen(false);
            }
          }}
          className="flex text-xs cursor-pointer text-[#505E8E] items-center"
        >
          <MdArrowBackIos className="mr-2" />
          Back
        </p>
      </div>
      <div className="px-8 space-y-2 py-4 bg-white">
        {/* <ToolTip
          text={data?.getSchoolMdrInfo.school_name}
          width="max-w-[28rem]"
        >
          <h1 className=" text-xl w-full capitalize  truncate font-medium text-edviron_black">
            School Name: {data?.getSchoolMdrInfo.school_name}
          </h1>
        </ToolTip> */}
      </div>
      {gateway_ratio_loading ? (
        <div className="flex justify-center items-center h-[80vh]">
          <AiOutlineLoading3Quarters className="text-4xl mx-auto animate-spin" />
        </div>
      ) : (
        <>
          <div className="grid grid-cols-4 p-4">
            <div>
              <p className=" text-[#777777] text-xs font-normal">
                Payment Mode
              </p>
            </div>
            <div>
              <p className=" text-[#777777] text-xs font-normal">Gateway 1</p>
            </div>
            <div>
              <p className=" text-[#777777] text-xs font-normal">Gateway 2</p>
            </div>
            <div>
              <p className=" text-[#777777] text-xs font-normal">Gateway 3</p>
            </div>
          </div>

          <div>
            {paymentMethods?.map((method: any, index: number) => (
              <div key={index} className="grid gap-8 grid-cols-4 p-4">
                <h3 className=" text-[#1B163B] text-base uppercase font-normal">
                  {method.mode.replace("_", " ")}
                </h3>

                <div className="col-span-3">
                  <GatewayRatio
                    method={method}
                    handleInputChange={handleInputChange}
                  />
                </div>

                {/* <input
                  type="number"
                  value={method.cashfree}
                  onChange={(e) =>
                    handleInputChange(index, "cashfree", e.target.value)
                  }
                  className={
                    "focus:outline-none disabled:bg-gray-200 transition-all duration-150 ease-in-out text-xs font-normal text-[#1B163B] px-2 py-1.5 w-full lg:max-w-[80%] rounded-md text-right "
                  }
                  min={0}
                  max={100}
                />

                <input
                  type="number"
                  disabled
                  value={method.easebuzz}
                  className={
                    "focus:outline-none disabled:bg-gray-200 transition-all duration-150 ease-in-out text-xs font-normal text-[#1B163B] px-2 py-1.5 w-full lg:max-w-[80%] rounded-md text-right "
                  }
                /> */}
              </div>
            ))}
          </div>
        </>
      )}
      <div className="flex justify-end items-center pr-10 pt-6">
        <button
          onClick={async () => {
            try {
              const res = await updateGatewayRatio({
                variables: {
                  school_id: allSchoolsIds,
                  trustee_id: trusteeId,
                  gateway_ratio: gatwayRatio,
                },
              });

              if (res.data?.addGatewayRatio) {
                if (res.data?.addGatewayRatio?.error) {
                  toast.error(res.data?.addGatewayRatio?.error);
                }
                if (res.data?.addGatewayRatio?.msg) {
                  toast.success(res.data?.addGatewayRatio?.msg);
                }
                setOpen(false);
              }
            } catch (error: any) {
              toast.error(error.message);
              setOpen(false);
            }
          }}
          className="px-10 py-1 w-40 h-10 bg-[#6F6AF8] disabled:bg-gray-300 disabled:text-black text-white rounded-md"
        >
          {loading ? (
            <AiOutlineLoading3Quarters className="text-xl mx-auto animate-spin" />
          ) : (
            "Set Ratio"
          )}
        </button>
      </div>
    </div>
  );
}

export default SetGatwayRate;
